import { presentNumber } from "../util/CommonUtils";

export const presentSettlement = ({ summary, orders }) => {

  const total = {
    sellAmount: presentNumber(summary.totalMenusPrice),
    adjust: presentNumber(summary.totalAdjust * -1),      // NOTE: 조정액은 네거티브로
    operationFee: presentNumber(summary.bcsPrice), 
    calculated: presentNumber(summary.billedAmount),
    totalQty: presentNumber(summary.totalQuantity),
    kpi: summary.meanMeal,
  };

  // loop orders 
  // NOTE: new api 는 serviceTime 구분하기 때문에 date 기준으로 합산 필요 
  const settlement = [];
  orders.forEach(o => {
    let found = settlement.find(el => el.date === o.date);
    if (!found) {
      found = {
        date: o.date,
        totalCount: 0,
        sellAmount: 0,
        adjust: 0,
        adjustMemo: null,
        calculated: 0,
        menu: [],
      };
      settlement.push(found);
    }
    if (o.serviceTime === '-1') { // adjust 
      found.adjust += o.grossAmount * -1;
      found.calculated += o.grossAmount;
      if (o.note && o.note.length > 0) {
        found.adjustMemo = (found.adjustMemo ? found.adjustMemo + '\n' : '') + o.note;
      }
    }
    else {
      found.totalCount += o.quantity;
      found.sellAmount += o.grossAmount;
      found.calculated += o.grossAmount;
      found.menu = found.menu.concat(
        o.menus.map(el => ({
          menuId: el.menuId,
          name: el.title,
          orderQty: el.quantity,
        }))
      );
    }
  });

  return {
    total,
    settlement: settlement.map(el => ({
      ...el,
      totalCount: presentNumber(el.totalCount),
      sellAmount: presentNumber(el.sellAmount),
      adjust: presentNumber(el.adjust),
      calculated: presentNumber(el.calculated),
    })),
  };
}